module.exports = __webpack_public_path__ + "img/CM-SL-CA-Lincoln-Modern.f7fc5ea7.jpg";